/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CategoryCell_category$ref: FragmentReference;
declare export opaque type CategoryCell_category$fragmentType: CategoryCell_category$ref;
export type CategoryCell_category = {|
  +id: string,
  +name: string,
  +$refType: CategoryCell_category$ref,
|};
export type CategoryCell_category$data = CategoryCell_category;
export type CategoryCell_category$key = {
  +$data?: CategoryCell_category$data,
  +$fragmentRefs: CategoryCell_category$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CategoryCell_category",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Category"
};
// prettier-ignore
(node/*: any*/).hash = 'b056f1e3e5466a3e6c320dc42a0a94a8';

module.exports = node;
